export const RoutesLink = {
  home: '/',
  termsConditions: '/terms-conditions',
  privacy_policy: '/privacy-policy',
  blog: '/blog',
  blog_detail: '/blog-detail',
  faq: "/faq",
  RefundCancellation: "/refund-cancellation",
  ContactUs: "/contact-us",
  ReqDeactivate: "/req-deactivation",
  EraseData: "/erase-data"
};
